import React, { useEffect, useMemo, useState } from "react";
import { Drawer } from "@mui/material";
import NotificationComponent from "./notificationComponent/notificationComponent";
import { baseUrl } from "../../../../network/constants/constants";
import { getConfig } from "../../../../network/auth";
import axios from "axios";
import { Spinner } from "react-bootstrap";
import CloseIcon from "@mui/icons-material/Close";

const NotificationScreen = ({ isDrawerOpen, toggleDrawer }) => {
  const [loading, setLoading] = useState(false);
  const [notifications, setNotifications] = useState([]);

  const config = useMemo(() => {
    return getConfig();
  }, []);

  const fetchNotification = () => {
    setLoading(true);
    axios
      .get(baseUrl + `superadmin/admin-notification/`, config)
      .then((response) => {
        setNotifications(response.data.results);
      })
      .catch((error) => {
        console.error("Gallery Error:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchNotification();
  }, []);

  return (
    <div className="notification-drawer">
        <Drawer
          anchor="right"
          open={isDrawerOpen}
          onClose={toggleDrawer(false)}
        >
          <div
            style={{
              zIndex: "999",
              width: "400px",
              padding: "20px",
              display: "flex",
              flexDirection: "column",
            }}
            onKeyDown={toggleDrawer(false)}
          >
            <CloseIcon className="mb-3 close-notification" onClick={toggleDrawer(false)}/>
            <NotificationComponent notifications={notifications} />
          </div>
        </Drawer>
    </div>
  );
};

export default NotificationScreen;
